/*
 * Copyright (C) 2018 - 2026 Entgra (Pvt) Ltd, Inc - All Rights Reserved.
 *
 * Unauthorised copying/redistribution of this file, via any medium is strictly prohibited.
 *
 * Licensed under the Entgra Commercial License, Version 1.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       https://entgra.io/licenses/entgra-commercial/1.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import React from 'react';
import {
  initializeI18n,
  supportedLocals,
} from '../../services/internationalization/i18n';
import { ConfigProvider } from 'antd';
import { I18nextProvider } from 'react-i18next';
import LocaleContext from '../LocaleContext';
import moment from 'moment';
import 'moment/locale/zh-cn';

moment.locale('en');

class Localizer extends React.Component {
  constructor(props) {
    super(props);
    let currentLocale = localStorage.getItem('locale');
    if (
      currentLocale == null ||
      // eslint-disable-next-line no-prototype-builtins
      !Object.prototype.hasOwnProperty.call(supportedLocals, currentLocale)
    ) {
      currentLocale = 'enUS';
      localStorage.setItem('locale', currentLocale);
    }
    this.i18nInstance = initializeI18n();
    this.i18nInstance.changeLanguage(currentLocale);
    this.state = {
      currentLocale,
      changeLocale: this.changeLocale,
    };
  }

  changeLocale = (key) => {
    if (Object.prototype.hasOwnProperty.call(supportedLocals, key)) {
      this.i18nInstance.changeLanguage(key);
      localStorage.setItem('locale', key);
      this.setState({ currentLocale: key });
    }
  };

  render() {
    return (
      <LocaleContext.Provider value={this.state}>
        <I18nextProvider i18n={this.i18nInstance}>
          <ConfigProvider
            theme={{
              token: {
                colorPrimary: '#903080',
                fontFamily: 'Poppins',
                colorBorder: 'var(--input-border-light)',
              },
              components: {
                Button: {
                  controlHeight: 32,
                  contentFontSize: 12,
                  fontWeight: 500,
                  contentLineHeight: 1.4,
                  paddingInline: 10,
                  paddingBlock: 0,
                  borderRadius: 6,

                  /* Default state */
                  defaultBg: '#f5f5f5',
                  defaultColor: 'var(--muted-text)',
                  defaultBorderColor: 'var(--soft-purple)',

                  /* Hover state */
                  defaultHoverBg: 'var(--accent)',
                  defaultHoverColor: 'var(--label-text-dark)',
                  defaultHoverBorderColor: 'var(--secondary)',
                },
                Menu: {
                  darkItemSelectedBg: '#f0f2f5',
                  itemBorderRadius: 0,
                  fontSize: 16,
                  darkSubMenuItemBg: 'transparent',
                  activeBarWidth: 0,
                  itemMarginInline: 0,
                  itemActiveBg: '#f0f2f5',
                },
                Layout: {
                  siderBg: 'linear-gradient(to bottom, #1C4C75 47.5%, #4288BA)',
                  triggerBg: 'transparent',
                },
                Typography: {
                  colorTextHeading: 'var(--card-light)',
                  titleMarginBottom: 0,
                },
                Form: {
                  itemMarginBottom: 0,
                  feedbackTextFontSize: 10,
                  labelFontSize: 13,
                  labelColor: 'var(--label-text-dark)',
                  labelFontWeight: 400,
                  labelRequiredMarkColor: '#ff4d4f',
                  labelHeight: 'auto',
                },
                Select: {
                  fontSize: 13,
                  optionFontSize: 10,
                },
              },
            }}
            locale={supportedLocals[this.state.currentLocale].antLocale}
          >
            {this.props.children}
          </ConfigProvider>
        </I18nextProvider>
      </LocaleContext.Provider>
    );
  }
}

export default Localizer;
